import styled, { css } from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'
import { Shadows } from 'builder/styles/shadows'
import { ButtonV2 } from 'builder/components/Button/components/ButtonV2/ButtonV2'

export const TooltipBody = styled.div<{ $isDragStep?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 20px;
  max-width: 380px;
  border-radius: 16px;
  background: ${Colors.White};

  ${Shadows.lightWithBorder.high};

  ${props =>
    props.$isDragStep
      ? Media.Phone`
          width: 315px;
        `
      : Media.Phone` 
          max-width: 350px;
    `}
`

export const TooltipContent = styled.div`
  display: flex;
  gap: ${Spacing['2XS']};
`

export const TooltipHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const TooltipTitle = styled.div`
  color: ${Colors.Neutral90};

  ${Typography.Body};
  ${FontWeights.Medium};
`

export const TooltipSubHeader = styled.div`
  color: ${Colors.Neutral70};

  ${Typography.Caption};
  ${FontWeights.Regular};
`

export const TagContainer = styled.div<{ $isDownloadStep?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  position: absolute;
  top: -20px;
  right: 16px;

  ${props =>
    props.$isDownloadStep &&
    css`
      left: 16px;
      right: unset;
    `}
`

export const Tag = styled.div`
  width: 100%;
  border-radius: 24px;
  border: 4px solid ${Colors.White};
  background-color: ${Colors.Blue10};
`

export const Step = styled.p`
  color: ${Colors.Blue60};
  padding: 6px 12px;
  gap: 10px;

  ${Typography.Caption};
  ${FontWeights.Medium};

  &::first-letter {
    text-transform: capitalize;
  }
`
export const SkipContainer = styled.div`
  display: flex;
  align-items: center;
`

export const TooltipSkipButton = styled(ButtonV2)`
  background: none;

  &:hover,
  &:focus-visible {
    background-color: ${Colors.Blue10};
  }

  &:active {
    background-color: ${Colors.Blue20};
  }
`
